import { Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { ModaleComponent } from 'app/generic/modale/modale.component';
import { HttpClient } from '@angular/common/http';

/* @Component({
  providers: [ModaleComponent]
}) */
export class JwtService {

  constructor(public router: Router,
              public modalComponent: ModaleComponent) {
    
  }

  errorCount:boolean = false;
  errorCountAdmin:boolean = false;

  public getOptions(): RequestOptions {

    let headers = new Headers({ 'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken') });
    let options = new RequestOptions({ headers: headers });
    return options;

  }

  protected handleError(error: any): Promise<any> {

    /* if (error.status == 0 || error.status == 404 || error.status == 504 || error.status == 500 || error.status == 401 || error.status == 400) {
      
      this.closeAllModal();
      this.openModalResponse("ATTENZIONE","C'è stato un errore server durante la richiesta effettuata.</br>"
                              +"Si prega di riprovare più tardi e se il problema dovesse persistere</br>"
                              +"contattare l'amministratore di sistema.");

      if(error.status == 401) {
        this.logout();
      }


    } */

    console.log("handleError > "+JSON.stringify(error));

    return Promise.reject(error.message || error);
  }

  closeAllModal() {
    var arrayModal = document.getElementsByClassName('close-modal');
    for(var i = 0; i < arrayModal.length; i++){
      let element: HTMLElement = document.getElementsByClassName('close-modal')[i] as HTMLElement;
      element.click();
    }
  }

  logout() {
    this.router.navigate(['/auth/logout']);
  }

  openModalResponse(titolo: any, messaggio: any): void {

    this.modalComponent.openModal(titolo, messaggio);

  }

}